import React from 'react';
import * as S from './BreadCrumb.styles';

const BreadCrumb = () => {
    return(
      <S.BreadCrumbOuterWrap>
        <S.BreadCrumbLinkWrap>
          <S.BreadCrumbLink>My Account</S.BreadCrumbLink>
        </S.BreadCrumbLinkWrap>
        <S.BreadCrumbLinkWrap>
          <S.BreadCrumbArrow>></S.BreadCrumbArrow>
        </S.BreadCrumbLinkWrap>
        <S.BreadCrumbLinkWrap>
          <S.BreadCrumbLink className="active">My Bookings</S.BreadCrumbLink>
        </S.BreadCrumbLinkWrap>
      </S.BreadCrumbOuterWrap>
    );
}

export default BreadCrumb;